import React from 'react'
import Section from '../../common/section/section'
import { MembershipBilling } from 'memberships/schema'
import { DateFormats, formatISOString } from 'utils/dates'
import InfoRow, { InfoRowContainer } from 'uiComponents/infoRow'
import { parse, addMonths } from 'date-fns'
import Badge from 'uiComponents/badge/badge'
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import './billing.scss'

interface BillingSectionProps {
    billing?: MembershipBilling
    isLoading?: boolean
}

const BillingSection = ({ billing, isLoading }: BillingSectionProps) => {
    let paymentMethodText, expirationDateValue, paymentScheduleText, nextPaymentText

    if (billing) {
        paymentMethodText =
            billing.paymentMethod === 'creditcard'
                ? 'Credit card'
                : billing.paymentMethod === 'ideal'
                ? 'iDEAL'
                : billing.paymentMethod

        if (billing.expirationDate) {
            const expirationDate = parse(billing.expirationDate, 'MM/yy', new Date())
            const isCardExpired = new Date() > addMonths(expirationDate, 1)
            expirationDateValue = (
                <>
                    {formatISOString(expirationDate, 'MM/yyyy')}
                    {isCardExpired && (
                        <Badge variant="error">
                            <FontAwesomeIcon icon={faExclamationTriangle as IconProp} />
                            Expired
                        </Badge>
                    )}
                </>
            )
        }

        paymentScheduleText =
            billing.paymentSchedule === 'P1Y' ? 'Yearly' : billing.paymentSchedule === 'P1M' ? 'Monthly' : undefined

        if (billing.nextPayment) {
            nextPaymentText = formatISOString(billing.nextPayment, DateFormats.EXTRA_LONG_DATE)
        }
    }

    return (
        <Section className="billing" title="Billing">
            <InfoRowContainer loading={isLoading}>
                <InfoRow label="Linked e-mail" className="linked-email" value={billing?.linkedEmail} />
                <InfoRow label="Payment method" className="payment-method" value={paymentMethodText} />
                {billing?.paymentMethod === 'creditcard' || !billing?.paymentMethod ? (
                    <>
                        <InfoRow label="Card number" className="card-number" value={billing?.paymentMethodDetails} />
                        <InfoRow
                            label="Card expiration date"
                            className="card-expiration-date"
                            value={expirationDateValue}
                        />
                    </>
                ) : (
                    <InfoRow label="Account number" className="account-number" value={billing?.paymentMethodDetails} />
                )}
                <InfoRow label="Payment schedule" className="payment-schedule" value={paymentScheduleText} />
                <InfoRow label="Next payment" className="next-payment" value={nextPaymentText} />
            </InfoRowContainer>
        </Section>
    )
}
export default BillingSection
